export type TwilioFlexRole = 'agent' | 'supervisor' | 'admin';

export const TwilioFlexRole = {
  agent: 'agent' as TwilioFlexRole,
  supervisor: 'supervisor' as TwilioFlexRole,
  admin: 'admin' as TwilioFlexRole,
};
